import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OnedocLogo from '../svgs/OnedocLogo/OnedocLogo';
import { Menu } from 'antd';
import { menuItems } from '../Leftbar/MenuItems';
import { useFileNavigationContext } from '../../contexts/FileNavigationContext';
import { useNavigate } from 'react-router-dom';
import { setCollapseLeftBar } from '../../features/organization/organizationSlice';
import WorkspaceMenu from '../Leftbar/WorkspaceMenu';

const index = ({ setIsCollaspse, activeStaticMenu, isCollaspse, setOpenWorkspaceCreateModal, popoverMenuContent }) => {
  const { setCurrentSelected } = useFileNavigationContext();
  const navigate = useNavigate();
  const collapseLeftBar = useSelector((state) => state.organization?.collapseLeftBar);
  const isAutoCollapseLeftbar = useSelector((state) => state.organization?.isAutoCollapseLeftbar);
  const activeWorkspace = useSelector((state) => state.organization?.activeWorkspace);

  const dispatch = useDispatch();

  const staticMenuClickHandler = useCallback(
    (e) => {
      setCurrentSelected('');
      navigate(e.key);
      setIsCollaspse(true);
      if (isAutoCollapseLeftbar) {
        dispatch(setCollapseLeftBar(true));
      }
    },
    [setCurrentSelected, navigate, setIsCollaspse, isAutoCollapseLeftbar, dispatch]
  );

  return (
    <>
      {/* Logo Section */}
      {!collapseLeftBar && (
        <div className="logo-section">
          <OnedocLogo />
        </div>
      )}

      {/* Navigation Menu */}
      <Menu
        mode="inline"
        items={menuItems}
        className="nav-menu"
        style={{ border: 'none' }}
        onClick={staticMenuClickHandler}
        selectedKeys={[activeStaticMenu]}
      />

      {/* Divider */}
      <div className="divider" />

      {/* Workspace Section */}
      {activeWorkspace && (
        <WorkspaceMenu
          activeWorkspace={activeWorkspace}
          collapseLeftBar={collapseLeftBar}
          isCollaspse={isCollaspse}
          setIsCollaspse={setIsCollaspse}
          setOpenWorkspaceCreateModal={setOpenWorkspaceCreateModal}
          popoverMenuContent={popoverMenuContent}
        />
      )}
    </>
  );
};

export default index;
